import { useState } from "react";
import { Timeline, Empty, Pagination, Spin } from "antd";
import trans from "../../../utils";
import { formatDateString } from "../../../JsHelpers/DateFormat";
import { useGetServiceRequestHistoryQuery } from "../../../Redux/service/Dispatcher/Dispatcher";

const ACTION_TITLES = {
  CREATED: "Request Created",
  UPDATED: "Request Updated",
  ASSIGNED: "Technician Assigned",
  REASSIGNED: "Technician Reassigned",
  TASK_CREATED: "Task Created",
};

const PAGE_SIZE = 10;

export default function ActivityTimeline({ requestId }) {
  const [page, setPage] = useState(1);
  const { data, isFetching } = useGetServiceRequestHistoryQuery(
    { id: requestId, page, limit: PAGE_SIZE },
    { skip: !requestId },
  );
  const history = data?.data || [];
  const total = data?.pagination?.totalItems ?? history.length;

  if (isFetching) {
    return <Spin />;
  }

  if (history.length === 0) {
    return <Empty description={trans("No activity yet")} />;
  }

  return (
    <>
      <Timeline
        items={history.map((entry) => ({
          key: entry.id,
          children: (
            <div>
              <div className="fw-500">
                {formatDateString(entry.changedAt)} — {entry.userName}
                {entry.userRole ? ` (${trans(entry.userRole)})` : ""}
              </div>
              <div>{trans(ACTION_TITLES[entry.action] || entry.action)}</div>
              {(entry.previousValue || entry.newValue) && (
                <div className="neutral-400">
                  {entry.previousValue || trans("No Action")} → {entry.newValue}
                </div>
              )}
              {entry.notes && <div className="neutral-400">{entry.notes}</div>}
            </div>
          ),
        }))}
      />
      {total > PAGE_SIZE && (
        <div className="d-flex justify-content-end mt-2">
          <Pagination
            current={page}
            pageSize={PAGE_SIZE}
            total={total}
            onChange={setPage}
            size="small"
            showSizeChanger={false}
          />
        </div>
      )}
    </>
  );
}
